export enum AuthMethods {
  NONE = 'none',
  FORM = 'form',
  EXTERNAL = 'external'
}
